/*
 * Public API Surface of ngx-document-scanner
 */

export * from './lib/ngx-document-scanner.module';
export * from './lib/components/image-editor/ngx-doc-scanner.component';
export * from './lib/PublicModels';
